import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { style: {"padding":"20px"} }
const _hoisted_3 = { style: {"padding":"10px","background-color":"#FAFAFA","text-align":"center"} }

import { ref, reactive } from 'vue'
import { layer } from '@layui/layer-vue'
import { addAgent, allAgent, disableUsers,settleDccounts,getMeasure } from '../../api'



export default /*#__PURE__*/_defineComponent({
  __name: 'agentList',
  setup(__props) {

const copyToClipboard=(text:any)=> {
  const textarea = document.createElement('textarea');
    textarea.value = text;
    // 将 textarea 添加到 body 中
    document.body.appendChild(textarea);
    // 选中 textarea 中的内容
    textarea.select();
    // 执行复制命令
    document.execCommand('copy');
    // 移除 textarea 元素
    document.body.removeChild(textarea);
    layer.msg('复制成功')
}



const search = reactive({
  key: "",
})


const loading = ref(false);

const dataSource = ref([]);

const selectedKeys = ref([]);

const page = reactive({ current: 1, limit: 10, total: 0 });

const columns = ref([
{ title: "账号", key: "userName", align: "center",width: "100px" },
    { title: "推广地址", key: "invitationCode", align: "center" , customSlot: "invitationCode",width: "90px"},  
    { title: "今预览", key: "visitsToday", align: "center"},
    { title: "总预览", key: "totalVisits", align: "center"},
    { title: "今ip", key: "todayIp", align: "center"},
    { title: "总ip", key: "totalIp", align: "center"},
    { title: "今下载", key: "dowdsToday", align: "center"},
    { title: "总下载", key: "totalDowds", align: "center" , customSlot: "totalDowds"},  
    // { title: "已结下载", key: "closedTotalDowds", align: "center" },
    { title: "今安装", key: "inviteToday", align: "center"},
    { title: "总安装", key: "totalInvite", align: "center", customSlot: "totalInvite"},
    // { title: "已结安装", key: "closedTotalInvite", align: "center" },
    { title: "今注册", key: "registerToday", align: "center"},
    { title: "总注册", key: "totalRegister", align: "center", customSlot: "totalRegister"},
    // { title: "未结注册", key: "closedTotalRegister", align: "center" }, 
    { title: "单价", key: "univalent", align: "center" },
    { title: "状态", key: "state", align: "center", customSlot: "state" },    
    { title: "备注", key: "agentRemark", align: "center" },
  { title: "结算时间", key: "depositBalanceTime", align: "center" },
  { title: "注册时间", key: "addTime", align: "center" },
  { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center", width: "160px" }
]);


const getAllAdminUser = () => {
  loading.value = true;
  var data = { "page": page.current, "limit": page.limit, "key": search.key };
  allAgent(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}
//获取数据
getAllAdminUser();


const change = (page: any) => {
  getAllAdminUser();
}

const sortChange = (key: any, sort: any) => {
  layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}

//禁用或者开启
const changedelFlag = (row: any) => {
  var data = { "key": row.userId, "id": row.state };
  disableUsers(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllAdminUser();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}

//查询接口
const searchUser = () => {
  page.current = 1;
  getAllAdminUser();
}



const agent = reactive({
  userId: "",
  userName: "",
  password: "",
  univalent: "", 
  agentRemark: ""
})


const updateUser = (row: any) => {
  agent.userId = row.userId;
  agent.userName = row.userName;
  agent.password = "";
  agent.univalent = row.univalent;
  agent.agentRemark = row.agentRemark; 

  isDisabled.value = true;
  visible11.value = !visible11.value;
}

const layFormRef11 = ref();

const visible11 = ref(false);

const isDisabled = ref(false);

const changeVisible11 = () => {
  agent.userId = "";
  agent.userName = "";
  agent.password = "";
  agent.univalent = ""; 
  agent.agentRemark = "";
  isDisabled.value = false;
  visible11.value = !visible11.value;
}

const action11 = ref([
  {
    text: "确认",
    callback: () => {
      addAgent(JSON.stringify(agent)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllAdminUser();
          visible11.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      visible11.value = false;

    }
  }
])


//结算
const settlement = (row: any) => {
  var data = { "key": row.userId }

  layer.confirm("请确定是否已结算”" + row.userName + "“代理",
    {
      btn: [
        {
          text: '确定', callback: (id: any) => {

            settleDccounts(JSON.stringify(data)).then((res: any) => {
              if (res != "" && res.code == 0) {
                getAllAdminUser();
                visible11.value = false;
                layer.msg("操作成功", { time: 1000, icon: 1 });
              }
            })



            layer.close(id);
          }
        },
        {
          text: '取消', callback: (id: any) => {
            layer.msg("取消");
            layer.close(id);
          }
        }
      ]
    }
  );

}



const openDrawer = function () {

}





const changeStatistics = (page: any) => {
  getAllstatistics();
  }
  


const dataSourceStatistics = ref([]);
const pageStatistics = reactive({ current: 1, limit: 10, total: 0 });

const columnsStatistics = ref([
{ title: "访问量", key: "totalVisits", align: "center"},
    { title: "ip量", key: "totalIp", align: "center"},
    { title: "下载量", key: "totalDowds", align: "center"},
    { title: "安装量", key: "totalInvite", align: "center"}, 
    { title: "注册量", key: "totalRegister", align: "center" },  
    { title: "时间", key: "timeStr", align: "center" }, 
  ]);

const  isStatistics= ref(false);
const userId = ref('');
const  statistics=(row: any)=>{  
  userId.value=row.userId
  isStatistics.value=!isStatistics.value 
  getAllstatistics();
}






const getAllstatistics = () => {
    loading.value = true;
    var data = { "page": pageStatistics.current, "limit": pageStatistics.limit, "key": userId.value };
    getMeasure(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSourceStatistics.value = res.data;
        pageStatistics.total = res.count;
      } else {
        dataSourceStatistics.value = [];
        pageStatistics.total = 0;
      }
    })
  }



return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "代理账号",
                      prop: "username",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入账号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: changeVisible11,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_switch, {
                      "model-value": row.state == 0 ? true : false,
                      onChange: ($event: any) => (changedelFlag(row)),
                      "onswitch-text": "正常",
                      "unswitch-text": "禁用"
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  totalDowds: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.totalDowds+row.closedTotalDowds), 1)
                  ]),
                  totalInvite: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.totalInvite+row.closedTotalInvite), 1)
                  ]),
                  totalRegister: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.totalRegister+row.closedTotalRegister), 1)
                  ]),
                  invitationCode: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (copyToClipboard(row.invitationCode))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("复制链接")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (statistics(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("统计")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateUser(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['400px', '630px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: agent,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "账户",
                prop: "userName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.userName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((agent.userName) = $event)),
                    disabled: isDisabled.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "密码",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((agent.password) = $event)),
                    type: "password",
                    placeholder: "无需修改请置空"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "单价",
                prop: "univalent"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.univalent,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((agent.univalent) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "agentRemark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入备注",
                    modelValue: agent.agentRemark,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((agent.agentRemark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"]),
    _createVNode(_component_lay_layer, {
      modelValue: isStatistics.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isStatistics).value = $event)),
      shade: false,
      area: ['1200px', '800px'],
      title: "统计列表"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_lay_table, {
            page: pageStatistics,
            height: '100%',
            columns: columnsStatistics.value,
            loading: loading.value,
            "data-source": dataSourceStatistics.value,
            "selected-keys": selectedKeys.value,
            "onUpdate:selectedKeys": _cache[7] || (_cache[7] = ($event: any) => ((selectedKeys).value = $event)),
            onChange: changeStatistics,
            onSortChange: sortChange
          }, null, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})